module.exports = __webpack_public_path__ + "img/jianyan.61ec3b60.png";